import { createContext, useContext } from 'react';

/**
 * True while the user has the Connector tool active. Per-node renderers
 * read this to enable a full-body source Handle so a drag from anywhere
 * on the node draws a connector — matching Miro/FigJam's tool-mode UX.
 */
export const ConnectorModeContext = createContext<boolean>(false);

export function useConnectorMode(): boolean {
  return useContext(ConnectorModeContext);
}
